import { render, staticRenderFns } from "./CardMarcacao.vue?vue&type=template&id=1c43253d&"
import script from "./CardMarcacao.vue?vue&type=script&lang=js&"
export * from "./CardMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports